export const isLinkAction = (eventTarget: HTMLElement) => {
  return (
    eventTarget.dataset.link ||
    eventTarget.parentElement?.dataset.link ||
    eventTarget.parentElement?.parentElement?.dataset.link
  );
};
